export const getTabSlotName = (tabName = 'unknown') => `tab(${tabName.toLowerCase().trim()})`
